import { Inject, Injectable } from '@angular/core';
import { Observable,  fromEvent as observableFromEvent } from 'rxjs';
import { filter,  map, tap } from 'rxjs/operators';
import { NB_WINDOW } from '@nebular/theme';

@Injectable({
  providedIn: 'root'
})
export class IframeCommunicationService {

  constructor(@Inject(NB_WINDOW) private window) {
  }

  public send(payload: any, target: Window = this.window.parent) {
    if (target !== this.window) {
      target.postMessage(payload, '*');
    }
  }

  public receive(id: string): Observable<any> {
    return observableFromEvent(this.window, 'message')
      .pipe(
        filter((msg: any) => msg.data && msg.data.id === id),
        map((msg: any) => msg.data),
      );
  }

  public sendFromParent(payload:any,target:Window = this.window){
    target.postMessage(payload,'*')
  }
  public receiveFromParent(id: string): Observable<any> {
    //console.log(id)
    return observableFromEvent(this.window.parent, 'message')
      .pipe(
        filter((msg: any) => msg.data && msg.data.id === id),
        //tap((msg: any) => console.log({id:id,message:msg.data})
        //),
        map((msg: any) => msg.data),
      );
  }
}

